import { useState, useCallback } from 'react';

let toastIdCounter = 0;

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const addToast = useCallback((type, message, duration = 5000) => {
    const id = ++toastIdCounter;
    const newToast = {
      id,
      type,
      message,
      duration,
    };

    setToasts((prev) => [...prev, newToast]);

    return id;
  }, []);

  const showSuccess = useCallback((message, duration) => {
    return addToast('success', message, duration);
  }, [addToast]);

  const showError = useCallback((message, duration) => {
    return addToast('error', message, duration);
  }, [addToast]);

  const showInfo = useCallback((message, duration) => {
    return addToast('info', message, duration);
  }, [addToast]);

  const showLoading = useCallback((message = 'Cargando...') => {
    return addToast('loading', message, 0);
  }, [addToast]);

  return {
    toasts,
    showSuccess,
    showError,
    showInfo,
    showLoading,
    removeToast,
  };
};

